export default {
  namespaced: true,
  victronenergy: {
    title: "Victron Energy",
    master_account: {
      title: "Conta Mestre",
      name: "Nome",
      description: "Descrição",
      api_email: "E-mail da API",
      api_password: "Senha da API",
      api_server: "Servidor da API",
      token: "Token",
      url_mqtt: "Url mqtt",
    },
    sites: {
      title: "Sites",
      name: "Nome",
      description: "Descrição",
      is_active: "Está Ativo",
      timezone: "Fuso Horário",
      status: "Status",
      has_mains: "Possui Rede Elétrica",
      has_generator: "Possui Gerador",
      device_icon: "Ícone do Dispositivo",
      favorite: "Favorito",
      devices: "Dispositivos",
    },
    devices: {
      title: "Dispositivos",
      name: "Nome",
      product_name: "Nome do Produto",
      product_code: "Código do Produto",
      machine_serial_number: "Número de Série",
      firmware_version: "Versão do Firmware",
      device_class: "Classe do Dispositivo",
      last_connection: "Última Conexão",
      gui_v2_status: "Status GUI V2",
      has_victron_connect: "Possui Victron Connect",
    }
  }
};
